import {debouncer, slideToggle} from '../utility/utils';
import Dom from '../utility/dom';
import Modal from './accessibility';
import {smoother} from "../utility/gsap";

export const initializeNav = (event) => {
  // Menu Toggle
  const nav = document.querySelector('.main-navigation');
  nav.isOpen = false;
  const menu_toggle = nav.querySelector('.menu-toggle');
  const parentNavItems = nav.querySelectorAll('li:has(ul) > a');
  const childMenus = nav.querySelectorAll('ul ul');

  const get_is_desktop = () => {
    return menu_toggle.offsetParent === null ? true : false;
  }

  menu_toggle.addEventListener('click', function(e){
    if(!nav.isOpen){
      menuOpen();
    }
    else {
      menuClose();
    }
  });

  if(parentNavItems.length > 0){
    parentNavItems.forEach(item => {
      item.addEventListener('click', function(e){
        const is_mobile = !get_is_desktop();
        if(is_mobile){
          if(e.target.closest('.plus_icon') || item.getAttribute('href') === '#'){
            e.preventDefault();
            const targetList = e.target.closest('li').querySelector('ul');
            if(targetList){
              // Toggle the class for the dropdown
              slideToggle(targetList);
              targetList.classList.toggle('toggled');
              
              if(targetList.classList.contains('toggled')){
                targetList.setAttribute('aria-hidden', 'false');
              }
              else {
                targetList.setAttribute('aria-hidden', 'true');
              }

              item.classList.toggle('active');
            }
          }
        }
      }
      );
    });
  }

  const menuClose = () => {
    nav.isOpen = false;
    // Set closing class for css animation help
    nav.classList.add('closing');
    const navItems = nav.querySelectorAll('li');
    navItems.forEach(item => {
      item.classList.add('closing');
    });
    setTimeout(()=>{
      nav.classList.remove('closing');
      navItems.forEach(item=>{
        item.classList.remove('closing');
      })
    }, 700);
    
    // Set Active Class
    nav.classList.remove('toggled');
    menu_toggle.classList.remove('active');
    menu_toggle.blur();
    menu_toggle.textContent = 'Menu';
    Dom.body.classList.remove('scroll-lock');
    if(smoother){
      smoother.paused(false);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'false');

    // Handle focus trapping
    Modal.close(nav);
    menu_toggle.setAttribute('tabindex', '1');
  }

  const menuOpen = () => {
    nav.isOpen = true;

    // Set Active Class
    nav.classList.add('toggled');
    menu_toggle.classList.add('active');
    menu_toggle.blur();
    menu_toggle.textContent = 'Close';
    Dom.body.classList.add('scroll-lock');
    if(smoother){
      smoother.paused(true);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'true');

    // Handle focus trapping
    Modal.open(nav);

    // Call window resize to update css custom properties for window width
    window.dispatchEvent(new Event('resize'));
  }

  // Set menu state on load and resize if changing from mobile to desktop.
  const set_menu_state = () =>{
    // Since we don't know the menu breakpoint, check if the menu toggle is visible
    const is_desktop = get_is_desktop();

    // Desktop
    if(is_desktop){
      if(!nav.classList.contains('is_desktop')){
        nav.classList.add('is_desktop');
        nav.classList.remove('is_mobile');
      }

      // Reset any child menus that may have been toggled
      childMenus.forEach(menu => {
        if(menu.classList.contains('toggled')){
          menu.classList.remove('toggled');
          menu.setAttribute('aria-hidden', '');
        }
      });

      // if mobile state classes are present, remove them.
      if(nav.classList.contains('toggled')){
        menuClose();
        Modal.setToFocusable(nav);
      }

      // set aria-hidden if not already set to false
      if(menu_toggle.getAttribute('aria-expanded') !== 'true'){
        menu_toggle.setAttribute('aria-expanded', 'true');
      }
    }
    // Mobile
    else {
      if(!nav.classList.contains('is_mobile')){
        nav.classList.remove('is_desktop');
        nav.classList.add('is_mobile');
      }

      // Hide any child menus
      childMenus.forEach(menu => {
        menu.setAttribute('aria-hidden', 'true');
      });
      
      // set aria-hidden if not already set to true and if menu isn't currently active
      if(!nav.classList.contains('toggled') && menu_toggle.getAttribute('aria-expanded') !== 'false'){
        menu_toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
  set_menu_state();

  // Add SVG Plus icons to nav items
  const navItems = nav.querySelectorAll('.menu-item-has-children > a');
  navItems.forEach(item => {
    if(!item.querySelector('.plus_icon')){
      const plusIconWrapper = document.createElement('span');
      plusIconWrapper.classList.add('plus-icon-transition-wrapper');
      const plusIcon = document.createElement('span');
      plusIcon.classList.add('svg-plus-icon');
      plusIcon.classList.add('plus_icon');
      plusIconWrapper.appendChild(plusIcon);
      item.appendChild(plusIconWrapper);
    }
  });

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_menu_state();
  }, 15));
};
